import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Tooltip,
  IconButton,
  Grid,
  Typography,
  Divider,
  MenuItem,
  Select,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import CreatableSelect from 'react-select/creatable';
import { forEach, set } from "lodash";

import { Dropdown } from "semantic-ui-react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { FormControl, InputLabel } from "@mui/material";
import { Checkbox, ListItemText, TextField } from "@mui/material";
import Select2 from 'react-select'
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

const DefineCriteriaModal = ({ campaign_id }) => {
  const [open, setOpen] = useState(false);
  const [eligibilityModalOpen, setEligibilityModalOpen] = useState(false);
  const [assignDegrees, setAssignDegrees] = useState([]);
  const [quotas, setQuotas] = useState([]);
  const [department, setDepartment] = useState("");

  const [all_departments, setAllDepartments] = useState([]);
  const [department_id, setDepartmentId] = useState();
  const [previousPrograms, setPreviousPrograms] = useState([]);
  const [previousSubjects, setPreviousSubjects] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState("");
  const [selectedProgramName, setSelectedProgramName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [campuses, setCampuses] = useState([]);
  const [faculties, setFaculties] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedCampus, setSelectedCampus] = useState(null);
  const [selectedFaculty, setSelectedFaculty] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedProgramLevel, setSelectedProgramLevel] = useState(null);

  const programLevelOptions = [
    { id: "all", name: "All" },
    { id: "Undergraduate (BS Programs)", name: "Undergraduate (BS Programs)" },
    { id: "5th Semester", name: "5th Semester (BS Programs)" },
    { id: "Graduate (MS, M-Phil Programs)", name: "Graduate (MS, M-Phil Programs)" },
    { id: "Doctorate (PhD Programs)", name: "Doctorate (PhD Programs)" }
  ];
  // Program-level eligibility criteria
  const [eligibilityCriteria, setEligibilityCriteria] = useState({
    test_required: "",
    test_name: [],  // Initialize as empty array instead of string
    test_datetime: "",
    test_venue: "",
    required_program: [],
    subjects: [],
    min_marks: "",
    matric_weights: 30,
    inter_weights: 70,
    bsc_weights: 0,
    bs_weights: 0,
    ma_weights: 0,
    mphil_weights: 0,
    phd_weights: 0,
    test_weights: 0,
    description: "",
    enable_course_work_option: 0,
  });
  const testOptions = [
    { value: 'University Test', label: 'University Test' },
    { value: 'ECAT', label: 'ECAT' },
    { value: 'MCAT', label: 'MCAT' },
    { value: 'NTS', label: 'NTS' },
    { value: 'GAT', label: 'GAT' },
    { value: 'IELTS', label: 'IELTS' }
  ];
  // Selected quotas and their seat allocations
  const [selectedQuotas, setSelectedQuotas] = useState([]);
  const [quotaSeats, setQuotaSeats] = useState([]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const getDepartments = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/department/get_departments`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllDepartments(data.departments);
      })
      .catch((error) => console.log(error));
  };
// Fetch campuses
const fetchCampuses = async () => {
  try {
    const response = await fetch(`${BASE_URL}/campus/get_campuses`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      // Add "All" option to campuses
      setCampuses([{ id: "all", name: "All" }, ...data.campuses]);
    } else {
      console.error("Failed to fetch campuses");
    }
  } catch (error) {
    console.error("Error fetching campuses:", error);
  }
};

// Fetch faculties by campus
const fetchFaculties = async (campusId) => {
  if (!campusId || campusId === "all") {
    setFaculties([{ id: "all", name: "All" }]);
    return;
  }
  
  try {
    const response = await fetch(`${BASE_URL}/faculty/get_faculties_by_campus/${campusId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      // Add "All" option to faculties
      setFaculties([{ id: "all", name: "All" }, ...data.faculties]);
    } else {
      console.error("Failed to fetch faculties");
    }
  } catch (error) {
    console.error("Error fetching faculties:", error);
  }
};

// Fetch departments by faculty
const fetchDepartments = async (facultyId) => {
  if (!facultyId || facultyId === "all") {
    setDepartments([{ id: "all", name: "All" }]);
    return;
  }
  
  try {
    const response = await fetch(`${BASE_URL}/department/get_departments_by_faculty/${facultyId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      // Add "All" option to departments
      setDepartments([{ id: "all", name: "All" }, ...data.departments]);
    } else {
      console.error("Failed to fetch departments");
    }
  } catch (error) {
    console.error("Error fetching departments:", error);
  }
};
// Handle campus selection
const handleCampusChange = (option) => {
  const campusId = option?.id || null;
  setSelectedCampus(campusId);
  setSelectedFaculty(null);
  setSelectedDepartment(null);
  
  if (campusId) {
    fetchFaculties(campusId);
  } else {
    setFaculties([]);
  }
};

// Handle faculty selection
const handleFacultyChange = (option) => {
  const facultyId = option?.id || null;
  setSelectedFaculty(facultyId);
  setSelectedDepartment(null);
  
  if (facultyId) {
    fetchDepartments(facultyId);
  } else {
    setDepartments([]);
  }
};

// Handle department selection
const handleDepartmentChange = (option) => {
  setSelectedDepartment(option?.id || null);
};

// Handle program level selection
const handleProgramLevelChange = (option) => {
  setSelectedProgramLevel(option?.id || null);
};

// Handle search input change


// Get filtered degrees based on all filters
const getFilteredDegrees = () => {
  if (!assignDegrees) return [];
  
  return assignDegrees.filter(degree => {
    // Filter by campus
    const campusMatch = !selectedCampus || selectedCampus === "all" || degree.campus_id === selectedCampus;
    
    // Filter by faculty
    const facultyMatch = !selectedFaculty || selectedFaculty === "all" || degree.faculty_id === selectedFaculty;
    
    // Filter by department
    const departmentMatch = !selectedDepartment || selectedDepartment === "all" || degree.department_id === selectedDepartment;
    
    // Filter by program level
    const programLevelMatch = !selectedProgramLevel || selectedProgramLevel === "all" || degree.program_level === selectedProgramLevel;
    
    // Filter by search query
    const searchMatch = !searchQuery || degree.degree_name.toLowerCase().includes(searchQuery.toLowerCase());
    
    return campusMatch && facultyMatch && departmentMatch && programLevelMatch && searchMatch;
  });
};
// Fetch campuses on component mount
useEffect(() => {
  fetchCampuses();
}, []);

// Reset faculties when campus changes
useEffect(() => {
  if (selectedCampus) {
    fetchFaculties(selectedCampus);
  } else {
    setFaculties([]);
  }
}, [selectedCampus]);

// Reset departments when faculty changes
useEffect(() => {
  if (selectedFaculty) {
    fetchDepartments(selectedFaculty);
  } else {
    setDepartments([]);
  }
}, [selectedFaculty]);

  
  // Filter programs based on search query
  const filteredPrograms = previousPrograms.filter((program) =>
    program.name.toLowerCase().includes(searchQuery)
  );
  
  const handleRequiredProgramChange = (event) => {
    const value = event.target.value; // Get selected programs
    setEligibilityCriteria(prev => ({
      ...prev,
      required_program: value,
    }));
  };

  const handleCriteriaChange = (event) => {
    const { name, value } = event.target;
    setEligibilityCriteria(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleToggleProgram = (programName) => {
    const currentSelectedPrograms = eligibilityCriteria.required_program;
    const isProgramSelected = currentSelectedPrograms.includes(programName);
    const updatedPrograms = isProgramSelected
      ? currentSelectedPrograms.filter((program) => program !== programName)
      : [...currentSelectedPrograms, programName];

    setEligibilityCriteria(prev => ({
      ...prev,
      required_program: updatedPrograms,
    }));
  };

  const addSubject = () => {
    setEligibilityCriteria(prev => ({
      ...prev,
      subjects: [...prev.subjects, {
        required_program: "",
        subject: "",
        minMarks: "",
      }]
    }));
  };

  const handleSubjectChange = (subjectIndex, event) => {
    const { name, value } = event.target;
    setEligibilityCriteria(prev => {
      const updatedSubjects = [...prev.subjects];
      updatedSubjects[subjectIndex][name] = value;
      return {
        ...prev,
        subjects: updatedSubjects,
      };
    });
  };

  const removeSubject = (subjectIndex) => {
    setEligibilityCriteria(prev => {
      const updatedSubjects = [...prev.subjects];
      updatedSubjects.splice(subjectIndex, 1);
      return {
        ...prev,
        subjects: updatedSubjects,
      };
    });
  };
  
  // Handle selection of quota
  const handleQuotaSelection = (event) => {
    const selectedQuotaId = event.target.value;
    const selectedQuota = quotas.find(q => q.id === selectedQuotaId);
    
    if (selectedQuota && !selectedQuotas.some(q => q.id === selectedQuotaId)) {
      setSelectedQuotas([...selectedQuotas, selectedQuota]);
      // Initialize seats and max age for the newly selected quota
      setQuotaSeats([...quotaSeats, { quota_id: selectedQuotaId, seats: "", max_age: "30" }]);
    }
  };
  
  // Remove a selected quota
  const handleRemoveQuota = (quotaId) => {
    setSelectedQuotas(selectedQuotas.filter(q => q.id !== quotaId));
    setQuotaSeats(quotaSeats.filter(q => q.quota_id !== quotaId));
  };
  
  // Handle quota seat allocation changes
  const handleQuotaSeatChange = (quotaId, field, value) => {
    const updatedQuotaSeats = quotaSeats.map(quota => 
      quota.quota_id === quotaId ? { ...quota, [field]: value } : quota
    );
    setQuotaSeats(updatedQuotaSeats);
  };

  const handleSave = () => {
    // Calculate the sum of weights to validate
    let totalWeight = 0;
    totalWeight += parseFloat(eligibilityCriteria.matric_weights || 0);
    totalWeight += parseFloat(eligibilityCriteria.inter_weights || 0);
    totalWeight += parseFloat(eligibilityCriteria.bsc_weights || 0);
    totalWeight += parseFloat(eligibilityCriteria.bs_weights || 0);
    totalWeight += parseFloat(eligibilityCriteria.ma_weights || 0);
    totalWeight += parseFloat(eligibilityCriteria.mphil_weights || 0);
    totalWeight += parseFloat(eligibilityCriteria.phd_weights || 0);
    totalWeight += parseFloat(eligibilityCriteria.test_weights || 0);

    // Check if any quotas are selected
    if (selectedQuotas.length === 0) {
      toast.error("Please select at least one quota to define seats.");
      return;
    }


    
    // Check if max age is provided for each quota
    for (const quota of quotaSeats) {
      if (!quota.max_age) {
        toast.error("Please provide maximum age for all selected quotas.");
        return;
      }
    }
    
    // Prepare the payload
    const data = {
      program_id: selectedProgram,
      campaign_id: campaign_id,
      fields: quotaSeats.map(quota => ({
        ...eligibilityCriteria,
        quota_id: quota.quota_id,
        seats: quota.seats,
        max_age: quota.max_age
      }))
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    
    fetch(`${BASE_URL}/campaign/assign_criteria_to_degree`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        toast.success("Criteria defined successfully");
        handleEligibilityClose();
      })
      .catch((error) => console.error("Error:", error));
  };
  
  const getCriteria = async (id) => {
    let data = {
      program_id: id,
      campaign_id: campaign_id,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(
        `${BASE_URL}/campaign/get_criteria_in_degree`,
        requestOptions
      );
      const result = await response.json();

      if (result.criteria && result.criteria.length > 0) {
        // Take only the first criteria as the program-level criteria
        const firstCriteria = result.criteria[0];
        
        // Parse the program, subject and test_name data
        const tempPrograms = JSON.parse(
          firstCriteria.required_program.replace(/'/g, '"')
        );
        const tempSubjects = JSON.parse(
          firstCriteria.required_subjects.replace(/'/g, '"')
        );
        const tempTestNames = JSON.parse(
          firstCriteria.test_name.replace(/'/g, '"')
        );
        
        // Set the program-level criteria
        setEligibilityCriteria({
          test_required: firstCriteria.test_required,
          test_name: tempTestNames,  // Now using the parsed array
          test_datetime: firstCriteria.test_datetime || "",
          test_venue: firstCriteria.test_venue || "",
          required_program: tempPrograms,
          subjects: tempSubjects,
          min_marks: firstCriteria.min_marks,
          matric_weights: firstCriteria.matric_weights,
          inter_weights: firstCriteria.inter_weights,
          bsc_weights: firstCriteria.bsc_weights,
          bs_weights: firstCriteria.bs_weights,
          ma_weights: firstCriteria.ma_weights,
          mphil_weights: firstCriteria.mphil_weights,
          phd_weights: firstCriteria.phd_weights,
          test_weights: firstCriteria.test_weights,
          description: firstCriteria.description,
          enable_course_work_option: firstCriteria.enable_course_work_option,
        });
        
        // Extract quota-specific data and populate selectedQuotas and quotaSeats
        const quotaData = result.criteria.map(criteria => ({
          quota_id: criteria.quota_id,
          seats: criteria.seats,
          max_age: criteria.max_age || "30"  // Default max age to 30 if not provided
        }));
        
        setQuotaSeats(quotaData);
        
        // Find and select the quotas that have been previously defined
        const previouslySelectedQuotas = quotaData.map(q => {
          return quotas.find(quota => quota.id === q.quota_id);
        }).filter(Boolean);
        
        setSelectedQuotas(previouslySelectedQuotas);
      } else {
        // Reset if no criteria found
        setEligibilityCriteria({
          test_required: "",
          test_name: [],
          test_datetime: "",
          test_venue: "",
          required_program: [],
          subjects: [],
          min_marks: "",
          matric_weights: 30,
          inter_weights: 70,
          bsc_weights: 0,
          bs_weights: 0,
          ma_weights: 0,
          mphil_weights: 0,
          phd_weights: 0,
          test_weights: 0,
          description : "",
          enable_course_work_option: 0,
        });
        setSelectedQuotas([]);
        setQuotaSeats([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Reset on error
      setEligibilityCriteria({
        test_required: "",
        test_name: [],
        test_datetime: "",
        test_venue: "",
        required_program: [],
        subjects: [],
        min_marks: "",
        matric_weights: 30,
        inter_weights: 70,
        bsc_weights: 0,
        bs_weights: 0,
        ma_weights: 0,
        mphil_weights: 0,
        phd_weights: 0,
        test_weights: 0,
        description : "",
        enable_course_work_option: 0,
      });
      setSelectedQuotas([]);
      setQuotaSeats([]);
    }
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleEligibilityOpen = (id, name) => {
    getCriteria(id);
    setSelectedProgram(id);
    setSelectedProgramName(name);
    setEligibilityModalOpen(true);
  };
  
  const handleEligibilityClose = () => setEligibilityModalOpen(false);
  
  const fetchData = async (url, setter) => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      setter(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(
      `${BASE_URL}/campaign/get_degrees_in_campaign/${campaign_id}`,
      (data) => setAssignDegrees(data.degrees)
    );
    fetchData(`${BASE_URL}/quota/get_quotas`, (data) => setQuotas(data.quotas));
    fetchData(`${BASE_URL}/submit_application/get_previous_programs`, (data) =>
      setPreviousPrograms(data.previous_programs)
    );
    fetchData(
      `${BASE_URL}/submit_application/get_previous_subjects`,
      (data) => setPreviousSubjects(data.previous_subjects)
    );
  }, [open]);

  return (
    <div>
      <Tooltip title="Define Criteria" arrow>
        <IconButton onClick={handleOpen}>
          <PlaylistAddIcon className="icon-button-criteria" />
        </IconButton>
      </Tooltip>

      <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xl"
      PaperProps={{
        className: "dialog-paper",
        style: { minHeight: "300px" },
      }}
    >
      <DialogTitle id="responsive-dialog-title" className="dialog-title">
        Define Criteria for Assign Programs
      </DialogTitle>
      <DialogContent className="dialog-content-critera">
        {/* Filter Section */}
        <Grid container spacing={2} className="mb-4">
          {/* Campus Filter */}
          <Grid item xs={12} md={3}>
            <label className="label-large">Campus</label>
            <Select2
              id="filter_campus_id"
              name="filter_campus_id"
              placeholder="Select Campus"
              options={campuses}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id}
              value={campuses.find((campus) => campus.id === selectedCampus)}
              onChange={handleCampusChange}
              isSearchable
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </Grid>
          
          {/* Faculty Filter */}
          <Grid item xs={12} md={3}>
            <label className="label-large">Faculty</label>
            <Select2
              id="filter_faculty_id"
              name="filter_faculty_id"
              placeholder="Select Faculty"
              options={faculties}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id}
              value={faculties.find((faculty) => faculty.id === selectedFaculty)}
              onChange={handleFacultyChange}
              isSearchable
              className="react-select-container"
              classNamePrefix="react-select"
              isDisabled={!selectedCampus}
            />
          </Grid>
          
          {/* Department Filter */}
          <Grid item xs={12} md={3}>
            <label className="label-large">Department</label>
            <Select2
              id="filter_department_id"
              name="filter_department_id"
              placeholder="Select Department"
              options={departments}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id}
              value={departments.find((dept) => dept.id === selectedDepartment)}
              onChange={handleDepartmentChange}
              isSearchable
              className="react-select-container"
              classNamePrefix="react-select"
              isDisabled={!selectedFaculty}
            />
          </Grid>
          
          {/* Program Level Filter */}
          <Grid item xs={12} md={3}>
            <label className="label-large">Program Level</label>
            <Select2
              id="filter_program_level"
              name="filter_program_level"
              placeholder="Select Program Level"
              options={programLevelOptions}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id}
              value={programLevelOptions.find((level) => level.id === selectedProgramLevel)}
              onChange={handleProgramLevelChange}
              isSearchable
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </Grid>
          
          {/* Search by Program Name */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="search_program"
              placeholder="Search Program Name"
              variant="outlined"
              value={searchQuery}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        
        {/* Degrees List */}
        <Grid container spacing={2}>
          {getFilteredDegrees().length > 0 ? (
            getFilteredDegrees().map((degree) => (
              <Grid
                container
                item
                xs={12}
                spacing={2}
                key={`${degree.degree_id}-${degree.department_id}`}
                className="m-1"
              >
                <Grid item xs={6}>
                  <Typography variant="body1">{degree.degree_name}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    {degree.department_name} <br/>{degree.faculty_name}
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={6}
                  container
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <Button
                    variant="contained"
                    className="add-full-button m-1"
                    onClick={() => handleEligibilityOpen(degree.program_id, degree.degree_name)}
                  >
                    Define Criteria
                  </Button>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Typography variant="body1" align="center">
                No programs match your filter criteria
              </Typography>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          className="dialog-actions-button negative"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>

      <Dialog
        open={eligibilityModalOpen}
        onClose={handleEligibilityClose}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>Seat Allocation, Eligibility Criteria & Merit Formula for {selectedProgramName}</DialogTitle>
        <DialogContent>
          {/* Quota Selection and Seat Allocation with Max Age */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', fontSize: '1.2rem', color: '#1976d2' }}>
              Quota Selection and Seat Allocation
            </Typography>
            
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel id="quota-selection-label">Select Quota</InputLabel>
                  <Select
                    labelId="quota-selection-label"
                    id="quota-selection"
                    onChange={handleQuotaSelection}
                    label="Select Quota"
                    value=""
                    style={{height: '40px'}}
                  >
                    {quotas
                      .filter(quota => !selectedQuotas.some(q => q.id === quota.id))
                      .map((quota) => (
                        <MenuItem key={quota.id} value={quota.id}>
                          {quota.name}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            
            {selectedQuotas.length > 0 && (
  <div className="table-responsive mb-4">
    <table className="table table-hover">
      <thead className="thead-light">
        <tr>
          <th>Quota</th>
          <th>Seats</th>
          <th>Max Age</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {selectedQuotas.map((quota) => {
          const quotaSeat = quotaSeats.find(q => q.quota_id === quota.id);
          return (
            <tr key={quota.id}>
              <td>{quota.name}</td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  value={quotaSeat ? quotaSeat.seats : ""}
                  onChange={(e) => handleQuotaSeatChange(quota.id, "seats", e.target.value)}
                  placeholder="Enter seats"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  value={quotaSeat ? quotaSeat.max_age : "30"}
                  onChange={(e) => handleQuotaSeatChange(quota.id, "max_age", e.target.value)}
                  placeholder="Enter max age"
                />
              </td>
              <td>
                <Button 
                  onClick={() => handleRemoveQuota(quota.id)}
                >
                  Remove
                </Button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
)}
<Typography variant="body2" style={{ fontWeight: 'bold', color: '#1976d2' }}>
  Total Seats: {quotaSeats.reduce((total, quota) => total + (parseInt(quota.seats) || 0), 0)}
</Typography>

            
            {selectedQuotas.length === 0 && (
              <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                Please select at least one quota to define seats.
              </Typography>
            )}
          </Box>
          
          <Divider sx={{ my: 3 }} />
          
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Eligibility Criteria
            </Typography>
            
            {/* Test Requirements */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <div className="form-group">
                  <label>Test Required</label>
                  <select
                    className="form-control"
                    name="test_required"
                    value={eligibilityCriteria.test_required}
                    onChange={handleCriteriaChange}
                  >
                    <option value="">Select Test</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </Grid>
              
              {eligibilityCriteria.test_required === "yes" && (
                <>
                  <Grid item xs={12} md={6}>
                    <label>Which Test(s) are Required? If new, just write name and it will be created</label>
                    <CreatableSelect
                      isMulti
                      options={testOptions}
                      isClearable
                      isSearchable
                      name="test_name"
                      onChange={(selectedOptions) => {
                        setEligibilityCriteria(prev => ({
                          ...prev,
                          test_name: selectedOptions ? selectedOptions.map(opt => opt.value) : [],
                        }));
                      }}
                      value={
                        Array.isArray(eligibilityCriteria.test_name)
                          ? eligibilityCriteria.test_name.map(val => ({ value: val, label: val }))
                          : eligibilityCriteria.test_name
                            ? [{ value: eligibilityCriteria.test_name, label: eligibilityCriteria.test_name }]
                            : []
                      }
                    />
                  </Grid>
                  {/* Test Date & Time and Venue for University Test (if selected) */}
                  {Array.isArray(eligibilityCriteria.test_name) && eligibilityCriteria.test_name.includes("University Test") && (
                    <>
                      <Grid item xs={12} md={6}>
                        <div className="form-group">
                          <label>Test Date & Time</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            name="test_datetime"
                            value={eligibilityCriteria.test_datetime}
                            onChange={handleCriteriaChange}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <div className="form-group">
                          <label>Test Venue</label>
                          <input
                            type="text"
                            className="form-control"
                            name="test_venue"
                            value={eligibilityCriteria.test_venue}
                            onChange={handleCriteriaChange}
                            placeholder="Enter test venue"
                          />
                        </div>
                      </Grid>
                    </>
                  )}
                </>
              )}
              
              {/* Required Programs */}
              <Grid item xs={12} md={6}>
                <label className="form-label">Required Degrees</label>
                <Select2
                  isMulti={true}
                  isClearable
                  isSearchable
                  options={previousPrograms.map(program => ({ value: program.name, label: program.name }))}
                  value={eligibilityCriteria.required_program.map(name => ({ value: name, label: name }))}
                  onChange={selected => {
                    setEligibilityCriteria(prev => ({
                      ...prev,
                      required_program: selected ? selected.map(opt => opt.value) : [],
                    }));
                  }}
                  placeholder="Select required degrees"
                />
              </Grid>
              
              {/* Minimum Marks */}
              <Grid item xs={12} md={6}>
                <div className="form-group">
                  <label>Minimum Marks (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="min_marks"
                    value={eligibilityCriteria.min_marks}
                    onChange={handleCriteriaChange}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="form-group">
                  <label>Do You Want to Enable Course Work Option?</label>
                  <select
                    className="form-select"
                    name="enable_course_work_option"
                    value={eligibilityCriteria.enable_course_work_option}
                    onChange={handleCriteriaChange}
                  >
                    <option value={0}>No</option>
                    <option value={1}>Yes</option>
                  </select>
                </div>
              </Grid>
            </Grid>
            
            {/* Subject Requirements */}
            <Box sx={{ mt: 3 }}>
              {eligibilityCriteria.required_program.length > 0 && (
                <Button onClick={addSubject}>Add Subject</Button>
              )}
              
              {eligibilityCriteria.subjects.map((subject, subjectIndex) => (
                <Box key={subjectIndex} sx={{ mt: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={4}>
                      <div className="form-group">
                        <label>Program</label>
                        <select
                          className="form-select"
                          name="required_program"
                          value={subject.required_program}
                          onChange={(e) => handleSubjectChange(subjectIndex, e)}
                        >
                          <option value="">Select Program</option>
                          {eligibilityCriteria.required_program.map((degree, idx) => (
                            <option key={idx} value={degree}>
                              {degree}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Grid>
                    
                    <Grid item xs={12} md={4}>
                      <div className="form-group">
                        <label>Subject</label>
                        <select
                          className="form-select"
                          name="subject"
                          value={subject.subject}
                          onChange={(e) => handleSubjectChange(subjectIndex, e)}
                        >
                          <option value="">Select Subject</option>
                          {previousSubjects.map((subj, idx) => (
                            <option key={idx} value={subj.name}>
                              {subj.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Grid>
                    
                    <Grid item xs={12} md={3}>
                      <div className="form-group">
                        <label>Marks (%)</label>
                        <input
                          type="number"
                          className="form-control"
                          name="marks"
                          value={subject.marks}
                          onChange={(e) => handleSubjectChange(subjectIndex, e)}
                        />
                      </div>
                    </Grid>
                    
                    <Grid item xs={12} md={1}>
                      <Button onClick={() => removeSubject(subjectIndex)}>
                        Remove
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              ))}
            </Box>
            
            <Divider sx={{ my: 3 }} />
            
            {/* Merit Formula Section */}
            <Typography variant="h6" gutterBottom>
              Merit Formula
            </Typography>
            <Typography variant="subtitle2" color="error" gutterBottom>
              Enter 0 if not required. Total must equal 100%.
            </Typography>
            
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <div className="form-group">
                  <label>Matric Weightage (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="matric_weights"
                    value={eligibilityCriteria.matric_weights}
                    onChange={handleCriteriaChange}
                  />
                </div>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <div className="form-group">
                  <label>Intermediate Weightage (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="inter_weights"
                    value={eligibilityCriteria.inter_weights}
                    onChange={handleCriteriaChange}
                  />
                </div>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <div className="form-group">
                  <label>BSc Weightage (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="bsc_weights"
                    value={eligibilityCriteria.bsc_weights}
                    onChange={handleCriteriaChange}
                  />
                </div>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <div className="form-group">
                  <label>BS Weightage (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="bs_weights"
                    value={eligibilityCriteria.bs_weights}
                    onChange={handleCriteriaChange}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="form-group">
                  <label>MA/MSc Weightage (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="ma_weights"
                    value={eligibilityCriteria.ma_weights}
                    onChange={handleCriteriaChange}
                  />
                </div>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <div className="form-group">
                  <label>MPhil Weightage (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="mphil_weights"
                    value={eligibilityCriteria.mphil_weights}
                    onChange={handleCriteriaChange}
                  />
                </div>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <div className="form-group">
                  <label>PhD Proposal Weightage (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="phd_weights"
                    value={eligibilityCriteria.phd_weights}
                    onChange={handleCriteriaChange}
                  />
                </div>
              </Grid>
              
              {eligibilityCriteria.test_required === "yes" && (
                <Grid item xs={12} md={6}>
                  <div className="form-group">
                    <label>Test Weightage (%)</label>
                    <input
                      type="number"
                      className="form-control"
                      name="test_weights"
                      value={eligibilityCriteria.test_weights}
                      onChange={handleCriteriaChange}
                    />
                  </div>
                </Grid>
              )}
              <Grid item xs={12} md={12}>
                  <div className="form-group">
                    <label>Description</label>
                    <input
                      type="text"
                      className="form-control"
                      name="description"
                      value={eligibilityCriteria.description}
                      onChange={handleCriteriaChange}
                    />
                  </div>
                </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleEligibilityClose}
            className="dialog-actions-button negative"
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={handleSave}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DefineCriteriaModal;